'use client';

// ── Buffer · "after a payout" example ────────────────────────────────────────
// Figma "Moldura · Exemplo · depois do payout": desktop 12071:60013 (792×276),
// mobile 12471:10663 (366×380). The balance rail after a payout: starting
// balance block, buffer block, the locked Max Drawdown line and its labels.
// Figma positions everything absolutely (the blocks are not proportional to
// the amounts), so each breakpoint copies its frame. Sizes are Figma px / 8.

import type { CSSProperties } from 'react';
import { ExampleLabel, FigureFrame } from '../primitives';

const rem = (px: number) => `${px / 8}rem`;
const box = (x: number, y: number, w: number, h: number): CSSProperties => ({
  left: rem(x),
  top: rem(y),
  width: rem(w),
  height: rem(h),
});

const LABEL = 'absolute mb-0 whitespace-nowrap text-[2rem] leading-[3rem]';

function RailDesktop() {
  return (
    <div data-ui="figure.bufferAfterPayout.rail-desktop" className="relative hidden h-[14.5rem] w-full lg:block">
      <div data-ui="figure.bufferAfterPayout.start" className="absolute rounded-[0.25rem] bg-[#f2f4f3]" style={box(0, 40, 416.4, 48)}>
        <p className={`${LABEL} font-medium text-black/[0.64]`} style={{ left: rem(12), top: rem(14) }}>
          Starting balance $50,000
        </p>
      </div>
      <div data-ui="figure.bufferAfterPayout.buffer" className="absolute rounded-[0.25rem] bg-[#e2f3ef]" style={box(416.4, 40, 277.6, 48)}>
        <p className={`${LABEL} font-medium text-[#196551]`} style={{ left: rem(12), top: rem(14) }}>
          Buffer $2,500
        </p>
      </div>
      <div data-ui="figure.bufferAfterPayout.line" className="absolute bg-[#ac0003]" style={box(415.52, 28, 1.757, 72)} />
      <p className={`${LABEL} text-right font-normal text-[#ac0003]`} style={{ right: rem(744 - 408), top: rem(92) }}>
        Max Drawdown line locked at $50,000
      </p>
      <p className={`${LABEL} font-medium text-black`} style={{ left: rem(469), top: rem(6) }}>
        balance after payout $52,500
      </p>
    </div>
  );
}

function RailMobile() {
  return (
    <div data-ui="figure.bufferAfterPayout.rail-mobile" className="relative h-[21.5rem] w-full lg:hidden">
      <div className="absolute rounded-[0.25rem] bg-[#f2f4f3]" style={box(0, 40, 190.589, 48)} />
      <div className="absolute rounded-[0.25rem] bg-[#e2f3ef]" style={box(190.589, 40, 127.411, 48)} />
      <div className="absolute bg-[#ac0003]" style={box(189.589, 28, 2, 68)} />
      <p className={`${LABEL} font-medium text-black`} style={{ left: rem(87.04), top: rem(4) }}>
        balance after payout $52,500
      </p>
      <p className={`${LABEL} font-medium text-black/[0.64]`} style={{ left: rem(5.17), top: rem(100) }}>
        Starting balance $50,000
      </p>
      <p className={`${LABEL} font-medium text-[#196551]`} style={{ left: rem(2.81), top: rem(124) }}>
        Buffer $2,500
      </p>
      <p className={`${LABEL} text-right font-normal text-[#ac0003]`} style={{ right: rem(318 - 292.55), top: rem(148) }}>
        Max Drawdown line locked at $50,000
      </p>
    </div>
  );
}

export default function BufferAfterPayout() {
  return (
    <FigureFrame data-ui="figure.bufferAfterPayout" className="gap-[2.5rem] font-geist">
      <ExampleLabel>EXAMPLE · AFTER A PAYOUT</ExampleLabel>
      <RailDesktop />
      <RailMobile />
      <p
        data-ui="figure.bufferAfterPayout.note"
        className="mb-0 w-full text-[2rem] font-normal leading-[3rem] text-black/[0.64] lg:w-[70rem]"
      >
        The buffer is the room between your balance and the Max Drawdown line — losses up to this amount do not close
        your account.
      </p>
    </FigureFrame>
  );
}
